export default __webpack_public_path__ + "static/media/UploadIcon.25fa0847.svg";